
<main class="auth-wrap">
    <div class="loading-in-tab" *ngIf="tokenValid == 'validating'">
        <img src="/assets/images/loading.gif" alt="">
        <h5>Validating URL...</h5>
    </div>
    <div class="content" *ngIf="tokenValid != 'validating'">
        <img src="assets/images/logo-main.svg" class="img-fluid d-block m-auto" alt="logo">
        <h2 *ngIf="tokenValid==false" class="warning">Invalid URL</h2>
        <h2 *ngIf="formSubmitted==false && tokenValid==true">Sign up for your {{region == 'VA' ? 'Copilot' : region}} account</h2>
        <div class="form-wrap" *ngIf="formSubmitted==false  && tokenValid==true">
            <span class="form-error" *ngIf="passwordNotMatch == 'error'">Passwords are not matching</span>
            <form [formGroup]="signUpForm">
                <div class="input-wrapp">
                    <div class="form-group" [ngClass]="{'error': signUpForm.controls.password.touched && !signUpForm.controls.password.valid}">
                        <input #password type="{{passwordShow?'text':'password'}}" class="form-control set-password" formControlName="password" id="passwordInput"  validatePassword="password" autocomplete="off" placeholder="Password">
                        <span class="passsword-visible" [class.text]="passwordShow" (click)="passwordShow = !passwordShow"><i class="icon"></i></span>
                        <i #passwordInfo="ngbTooltip" class="icon-information" placement="right" ngbTooltip="Password should have minimum 8 and maximum 50 letters, should have atleast one uppercase, one lowercase ,one  symbol and one number"></i>
                    </div>
                    <div class="form-group">
                        <input type="{{confirmPasswordShow?'text':'password'}}" formControlName="confirmPassword" class="form-control" id="confirmPasswordInput" validatePassword="confirmPassword" placeholder="Confirm Password">
                        <a class="passsword-visible" [class.text]="confirmPasswordShow" (click)="confirmPasswordShow = !confirmPasswordShow"><i class="icon"></i></a>
                    </div>
                </div>
                <button [disabled]="!signUpForm.valid " type="button" class="btn btn-green" type="submit" (click)="reset_va()" tabindex="7">SIGN UP</button>
            </form>
        </div>
        <div class="form-wrap form-confirm" *ngIf="formSubmitted==true">
            <h2>
                <a *ngIf="region=='Dashboard'"href="{{dashboard_redirect_url}}">Click here to go to dashboard</a>
                <a *ngIf="region=='VA'"href="{{environment_prod_url}}">Click here to go to Copilot</a>
            </h2>
        </div>
    </div>
</main>
